import * as React from 'react'
import { useParams } from 'react-router-dom'
import { useDate } from '@/modules/drivers/stores/dateStore'
import { useActivity } from '@/modules/drivers/stores/activityStore'
import ChartDetailsTable from '@/modules/drivers/tabs/activities/components/chartDetails/ChartDetailsTable'
import {
  edgeToIsoDate,
  yearStringToRange,
} from '@/modules/drivers/stores/dateStore.utils'

const ChartDetails = () => {
  const {
    companyId,
    driverId,
    year: currentYear,
  } = useParams<{ companyId: string; driverId: string; year: string }>()
  const { setYear, year } = useDate()
  const { setType, refreshTrigger, chartRange, setChartRange } = useActivity()

  React.useEffect(() => {
    setChartRange(yearStringToRange(currentYear as string))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentYear])

  React.useEffect(() => {
    setType('chartDetails')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  React.useEffect(() => {
    if (year !== currentYear) setYear(currentYear)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentYear])

  const startTime =
    edgeToIsoDate(chartRange?.startDate ?? null) ?? `${currentYear}-01-01`
  const endTime =
    edgeToIsoDate(chartRange?.endDate ?? null) ?? `${currentYear}-12-31`

  const driverIds = React.useMemo(() => {
    const id = Number(driverId)
    return Number.isFinite(id) && id > 0 ? [id] : []
  }, [driverId])

  return (
    <ChartDetailsTable
      companyId={companyId as string}
      driverIds={driverIds}
      startTime={startTime}
      endTime={endTime}
      refreshTrigger={refreshTrigger}
    />
  )
}

export default ChartDetails
